import { SET_PLAYER } from './constants';

export const setPlayer = (payload) => ({ type: SET_PLAYER, payload });
